'use client';

import { Flex, Input, Box } from "@chakra-ui/react";
import { LuSearch, LuCircleX } from "react-icons/lu";
import { useState } from 'react';

export default function Search({ openedSearch, handleSearchToggle }) {
  const [isFocused, setIsFocused] = useState(false);

  const handleKeyUp = (e) => {
    if (e.key !== 'Enter') return;

    const value = e?.target?.value || '';

    if(value.trim() === '') return;

    const sluged = value
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/[\s_-]+/g, '-')
      .replace(/^-+|-+$/g, '');

    const portalUrl = process.env.NEXT_PUBLIC_APP_URL;
    const targetUrl = `${portalUrl}/pesquisa/${sluged}`;

    handleSearchToggle();

    window.location.href = targetUrl;
  }

  return (
    <Box>
      <Box
        position="fixed"
        top="0"
        left="0"
        backdropFilter="blur(3px)"
        w="100%"
        h="100%"
        zIndex="999999"
        display={openedSearch ? 'block' : 'none'}
      >
      </Box>

      <Box
        position="fixed"
        top="20%"
        left={openedSearch ? '50%' : '-200%'}
        bgColor="rgba(54, 57, 59, 0.8)"
        zIndex="9999999"
        transition="all .5s ease-in-out"
        p="8"
        w={{base: '90%', lg: '50%'}}
        transform="translateX(-50%)"
        rounded="md"
      >

        <Flex border="1px solid" borderColor="orange.500" borderRadius="md" alignItems="center" px="5px" w="100%" maxW="920px" position="realtive">
          <Flex w="30px" h="30px" justifyContent="center" alignItems="center">
            <LuSearch size={isFocused ? "1.6em" : "1.2em"}  color="gray.100" style={{ transition: 'all 0.3s ease' }} />
          </Flex>

          <Input
            placeholder="Pesquisar"
            border="none"
            size="sm"
            variant="unstyled"
            bg="none"
            fontSize={{ base: '1.2em', md: '1em' }}
            color="white"
            _placeholder={{
              color: isFocused ? 'red.300' : 'white',
              fontStyle: 'italic',
              fontWeight: '300',
              fontSize: isFocused ? "1.1em" : "1em",
              transition: 'all 0.3s ease'
            }}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
            onKeyUp={handleKeyUp}
            />

            <Box
              position="fixed"
              top="0"
              right="0"
              p="2"
              cursor="pointer"
              _hover={{color: 'orange.500'}}
              onClick={() => handleSearchToggle()}
            >
              <LuCircleX size="20" />
            </Box>
        </Flex>
    </Box>
  </Box>
  )
}
